import { LangFormatFunction } from '@b3/lang';

const getAccountFormFields = (isMobile: boolean, b3Lang: LangFormatFunction) => {
  const accountFormFields = [
    {
      name: 'label',
      label: b3Lang('quoteDraft.config.addressLabel'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'firstName',
      label: b3Lang('quoteDraft.config.firstName'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: isMobile ? 12 : 6,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'lastName',
      label: b3Lang('quoteDraft.config.lastName'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: isMobile ? 12 : 6,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'companyName',
      label: b3Lang('quoteDraft.config.company'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'country',
      label: b3Lang('quoteDraft.config.country'),
      required: false,
      default: '',
      fieldType: 'dropdown',
      options: [],
      xs: 12,
      variant: 'filled',
      size: 'small',
      replaceOptions: {
        label: 'countryName',
        value: 'countryCode',
      },
    },
    {
      name: 'address',
      label: b3Lang('quoteDraft.config.addressLine1'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'apartment',
      label: b3Lang('quoteDraft.config.addressLine2'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'city',
      label: b3Lang('quoteDraft.config.city'),
      required: false,
      default: '',
      fieldType: 'text',
      options: [],
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'state',
      label: b3Lang('quoteDraft.config.state'),
      required: false,
      default: '',
      fieldType: 'text',
      options: [],
      xs: isMobile ? 12 : 6,
      variant: 'filled',
      size: 'small',
      replaceOptions: {
        label: 'stateName',
        value: 'stateName',
      },
    },
    {
      name: 'zipCode',
      label: b3Lang('quoteDraft.config.zipCode'),
      required: false,
      default: '',
      fieldType: 'text',
      options: [],
      xs: isMobile ? 12 : 6,
      variant: 'filled',
      size: 'small',
    },
    {
      name: 'phoneNumber',
      label: b3Lang('quoteDraft.config.phoneNumber'),
      required: false,
      default: '',
      fieldType: 'text',
      xs: 12,
      variant: 'filled',
      size: 'small',
    },
  ];

  return accountFormFields;
};

export default getAccountFormFields;
